import { parseISO, isSameDay, isBefore, startOfDay, addDays } from 'date-fns'

export const useSpeedDialStore = defineStore('speedDialStore', {
  state: () => ({
    modalDespesasFiltradas: {
      exibir: false,
      titulo: 'Visualizar Despesas',
      filtroAtivo: 'vencidas',
      despesas: [] as any[],
      loading: false,
    },
  }),

  actions: {
    async abrirModalDespesas () {
      this.modalDespesasFiltradas.exibir = true
      await this.buscarDespesasFiltradas(this.modalDespesasFiltradas.filtroAtivo as any)
    },

    async abrirModalDespesasVencidas () {
      this.modalDespesasFiltradas.titulo = 'Despesas Vencidas'
      this.modalDespesasFiltradas.filtroAtivo = 'vencidas'
      this.modalDespesasFiltradas.exibir = true
      await this.buscarDespesasFiltradas('vencidas')
    },

    async abrirModalDespesasHoje () {
      this.modalDespesasFiltradas.titulo = 'Despesas que Vencem Hoje'
      this.modalDespesasFiltradas.filtroAtivo = 'hoje'
      this.modalDespesasFiltradas.exibir = true
      await this.buscarDespesasFiltradas('hoje')
    },

    async abrirModalDespesasProximas () {
      this.modalDespesasFiltradas.titulo = 'Próximas ao Vencimento (5 dias)'
      this.modalDespesasFiltradas.filtroAtivo = 'proximas'
      this.modalDespesasFiltradas.exibir = true
      await this.buscarDespesasFiltradas('proximas')
    },

    async alterarFiltro (filtro: 'vencidas' | 'hoje' | 'proximas') {
      this.modalDespesasFiltradas.filtroAtivo = filtro
      await this.buscarDespesasFiltradas(filtro)
    },

    async buscarDespesasFiltradas (filtro: 'vencidas' | 'hoje' | 'proximas') {
      this.modalDespesasFiltradas.loading = true

      try {
        const dashboardStore = useDashboardStore()

        // Busca todas as contas para alertas (que já filtra despesas não pagas)
        await dashboardStore.fetchContasParaAlertas()
        const todasDespesas = dashboardStore.contasAlertas

        const hoje = startOfDay(new Date())

        let despesasFiltradas: any[] = []

        switch (filtro) {
          case 'vencidas':
            despesasFiltradas = todasDespesas.filter((despesa: any) => {
              const vencimento = parseISO(despesa.vencimento)
              const vencimentoStartOfDay = startOfDay(vencimento)
              return isBefore(vencimentoStartOfDay, hoje)
            })
            break

          case 'hoje':
            despesasFiltradas = todasDespesas.filter((despesa: any) => {
              const vencimento = parseISO(despesa.vencimento)
              return isSameDay(vencimento, hoje)
            })
            break

          case 'proximas': {
            const cincoDias = addDays(hoje, 5)
            despesasFiltradas = todasDespesas.filter((despesa: any) => {
              const vencimento = parseISO(despesa.vencimento)
              const vencimentoStartOfDay = startOfDay(vencimento)
              return vencimentoStartOfDay > hoje && vencimentoStartOfDay <= cincoDias
            })
            break
          }
        }

        this.modalDespesasFiltradas.despesas = despesasFiltradas
      } catch (error) {
        console.error('Erro ao buscar despesas filtradas:', error)
        this.modalDespesasFiltradas.despesas = []
      } finally {
        this.modalDespesasFiltradas.loading = false
      }
    },

    fecharModal () {
      this.modalDespesasFiltradas.exibir = false
      this.modalDespesasFiltradas.despesas = []
      this.modalDespesasFiltradas.filtroAtivo = ''
    },

    abrirDespesa (despesaId: string) {
      const prestacaoStore = usePrestacaoDeContaStore()
      prestacaoStore.modalDetalhesDespesa.despesa_id = despesaId
      prestacaoStore.modalDetalhesDespesa.exibir = true
      this.fecharModal()
    },

    editarDespesa (despesa: any) {
      const prestacaoStore = usePrestacaoDeContaStore()
      prestacaoStore.modalEditarDespesa = {
        exibir: true,
        id: despesa.id,
        conta_id: despesa.conta_id,
        descricao: despesa.descricao,
        valor: despesa.valor,
        vencimento: despesa.vencimento,
        dataDoPagamento: despesa.data_pagamento,
        observacao: despesa.observacao,
        arquivos: [],
        criarLembrete: false,
        calendarioId: '',
        eventoCalendario: null,
        despesaNaoEfetiva: despesa.despesa_nao_efetiva || false,
        despesaEfetiva: despesa.despesa_efetiva || true,
      }
      this.fecharModal()
    },

    pagarDespesa (despesa: any) {
      const prestacaoStore = usePrestacaoDeContaStore()
      const store = useStore()

      // Modificar o objeto EXISTENTE, não criar um novo
      prestacaoStore.modalEfetuarPagamento.despesa_id = despesa.id
      prestacaoStore.modalEfetuarPagamento.data_pagamento = null
      // Não precisa definir exibir aqui, substituirModal fará isso

      // Use substituirModal to swap expense modal for payment modal
      store.substituirModal(
        prestacaoStore.modalEfetuarPagamento,
        this.modalDespesasFiltradas
      )
    },
  },

  getters: {
    quantidadeDespesasFiltradas: state => state.modalDespesasFiltradas.despesas.length,

    valorTotalDespesas: (state) => {
      return state.modalDespesasFiltradas.despesas.reduce((total, despesa) => {
        return total + parseFloat(despesa.valor.toString().replace(',', '.'))
      }, 0)
    },
  },
})
